module.exports = __webpack_public_path__ + "img/empty.3e3c1d82.png";